export default __webpack_public_path__ + "2bb6e9fe01984f13ac45744ace241394.svg";